/**
 * Utilitário para mapear ícones de arquivos baseados na extensão ou mimetype
 */

// Importa ícones da pasta assets (Vite processa imports de assets)
import csvIcon from "../assets/csv-14.svg";
import docIcon from "../assets/doc-54.svg";
import docxIcon from "../assets/docx-11.svg";
import gifIcon from "../assets/gif-52.svg";
import htmlIcon from "../assets/html-52.svg";
import jsonIcon from "../assets/json-9.svg";
import movIcon from "../assets/mov-32.svg";
import mp3Icon from "../assets/mp3-48.svg";
import mp4Icon from "../assets/mp4-25.svg";
import pdfIcon from "../assets/pdf.svg";
import pptIcon from "../assets/ppt.svg";
import txtIcon from "../assets/txt.svg";
import xlsIcon from "../assets/xls-23.svg";
import xlsxIcon from "../assets/xlsx-12.svg";
import xmlIcon from "../assets/xml-23.svg";
import zipIcon from "../assets/zip-75.svg";
import defaultIcon from "../assets/unknown-file-2.svg";

const iconMap = {
  // Documentos
  pdf: pdfIcon,
  doc: docIcon,
  docx: docxIcon,
  xls: xlsIcon,
  xlsx: xlsxIcon,
  csv: csvIcon,
  ppt: pptIcon,
  pptx: pptIcon,
  txt: txtIcon,
  rtf: docIcon,

  // Código/Dados
  html: htmlIcon,
  xml: xmlIcon,
  json: jsonIcon,
  js: htmlIcon,
  css: htmlIcon,

  // Comprimidos
  zip: zipIcon,
  rar: zipIcon,
  "7z": zipIcon,
  tar: zipIcon,
  gz: zipIcon,

  // Mídia (caso venha como documento)
  mp3: mp3Icon,
  wav: mp3Icon,
  mp4: mp4Icon,
  mov: movIcon,
  avi: movIcon,
  gif: gifIcon,
};

export function getFileIcon(filename, mimeType) {
  if (!filename) return defaultIcon;

  const extension = filename.split(".").pop().toLowerCase();

  // Tenta pegar pelo mapa de extensão
  if (iconMap[extension]) {
    return iconMap[extension];
  }

  // Se não achar, tenta inferir (lógica simples) ou retorna default
  return defaultIcon;
}
